// eslint-disable-next-line import/no-cycle
import { PluginSetup as Startup } from "./startup/index.js";
import ImagineSetup from "./imagine/PluginSetup.js";
export default {
  install: molten => {
    Startup.install(molten);
    ImagineSetup.install(molten);
  }
};